import React from 'react';
import { translate } from '../Services/translation';

const CheckoutPaymentMethods = ({
  paymentMethods,
  selectedId,
  pickupMethodId,
  onChange,
}) => {
  function isSelected(methodId) {
    return methodId === selectedId;
  }

  function ChangePaymentMethod(methodId) {
    onChange(methodId);
  }

  function renderMethod(method) {
    return (
      <label
        className={`checkout__payment-method ${
          isSelected(method.id) ? 'selected' : ''
        }`}
        key={method.id}
      >
        <input
          type="radio"
          name="paymentMethods"
          value={method.id}
          checked={method.id === selectedId}
          onChange={ChangePaymentMethod.bind(null, method.id)}
        />
        <span className="fake-radio"></span>
        <span className="method-text">
          <i className={method.icon}></i>
          <b> {translate(method.translateKeyForName)} </b>
          <div>
            <span>{translate(method.translateKeyForDescription)}</span>{' '}
            {method.id == pickupMethodId ? '' : method.formattedPrice}
          </div>
        </span>
      </label>
    );
  }

  return (
    <div className="checkout__payment">
      {paymentMethods && paymentMethods.map(renderMethod)}
    </div>
  );
};

export default CheckoutPaymentMethods;
